export const ERROR_BOUNDARY = 1;
export const SILENT_ERROR = 2;
